import React from 'react';
import styles from './ButtonWithIcon.module.scss';
import clsx from 'clsx';
import { ReactComponent as IconArrowRight } from 'images/new-icons/primary-arrow-right.svg';
import { useActions } from 'store/useActions';
import Button from '../Button';
import { useTranslation } from 'react-i18next';

export const ButtonWithIcon = ({ openBooking, disabled }) => {
  const { setIsButtonMenuVisible } = useActions();
  const {t} = useTranslation() as any
  return (
    <Button
      className={clsx(styles.button)}
      onClick={() => {
        openBooking(false);
        setIsButtonMenuVisible(false);
      }}
      disabled={disabled}
    >
      <p className={clsx(styles.buttonText)}>{t('Book')}</p>
      <div>
        <IconArrowRight />
      </div>
    </Button>
  );
};
